const livechat = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="16 1 0 1 0 11.77 3.2 11.77 3.2 15 6.4 11.77 16 11.77"/></svg>',
};

export { livechat as default };
